<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div mat-dialog-title>
  @if (data.move.id) {
  <span>Edit Move</span>
  }
  @if (!data.move.id) {
  <span>Add Move</span>
  }
  <button
    mat-icon-button
    (click)="handleEditComplete(false)"
    title="Cancel"
    class="close-button"
    tabindex="-1"
    >
    <mat-icon class="mdi-24px self-center" fontIcon="mdi-close-circle-outline"></mat-icon>
  </button>
</div>
@if (data && data.move) {
  <div mat-dialog-content>
    <div class="add-margin">
      <div>
        <mat-form-field class="description-field">
          <mat-label>Move Number</mat-label>
          <input matInput [(ngModel)]="data.move.moveNumber" />
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field class="description-field full-width">
          <mat-label>Move Description</mat-label>
          <input matInput [(ngModel)]="data.move.description" />
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field class="datetime-field">
          <mat-label>Situation Date / Time</mat-label>
          <input matInput [ngxMatDatetimePicker]="picker"
            [formControl]="situationDateFormControl" (inputChange)="saveMove('situationDate')"
            (dateChange)="saveMove('situationDate')" style="display: none;">
          <span (click)="data.canEdit && picker.open()">
            {{data.move.situationTime | date: 'dd MMM yyyy HH:mm'}} {{ getTimezoneAbbr() }}
          </span>
          <mat-datepicker-toggle matSuffix title="Choose Date/Time" [for]="$any(picker)" [disabled]="!data.canEdit">
          </mat-datepicker-toggle>
          <ngx-mat-datetime-picker #picker [showSpinners]=true [showSeconds]=false [stepHour]=1 [stepMinute]=5
            [stepSecond]=1 [touchUi]=false [enableMeridian]=true [disableMinute]=false [hideTime]=false [color]="'warn'">
            <ngx-mat-datepicker-actions>
              <button mat-stroked-button ngxMatDatepickerApply>Save</button>
              <button mat-stroked-button ngxMatDatepickerCancel>Cancel</button>
            </ngx-mat-datepicker-actions>
          </ngx-mat-datetime-picker>
        </mat-form-field>
      </div>
    </div>
      <div class="add-margin">
        <mat-label class="gray">Situation Description</mat-label>
        <angular-editor [placeholder]="'Enter situation description here...'" [(ngModel)]="data.move.situationDescription" [config]="editorConfig"></angular-editor>
      </div>
      <div class="cssLayoutRowStartCenter bottom-button">
        <div class="delete-button">
          <button mat-stroked-button (click)="handleEditComplete(true)" [disabled]="!data.canEdit || !errorFree()" style="margin-left: 40px;">Save</button>
        </div>
        <div class="delete-button">
          <button mat-stroked-button (click)="handleEditComplete(false)">Cancel</button>
        </div>
      </div>
    </div>
  }
